import React, { useState, useContext } from "react";
import LoanBankCharge from "./loanBankCharge";
import ModalPopUp from "../modalPopUp";
import commonContext from "../../../context/common";
import { leadType } from "../../../../app";

function BankChargeAgree(props) {
    const [bankChargePopupSwitch, setBankChargePopupSwitch] = useState(false);
    const lead = useContext(commonContext).lead as leadType;
    const setLead = useContext(commonContext).setLead;
    const leadError = useContext(commonContext).leadError;
    return (
        <>
            <div className="relative w-full">
                <div className="text-left">
                    <label className="custom-inputs inline-flex items-start">
                        <input
                            type="checkbox"
                            onClick={() =>
                                setLead({ LDIAgree: !lead.LDIAgree })
                            }
                            defaultChecked={lead.LDIAgree}
                        />
                        <span></span>
                        <span className="ml-2 text-sm md:text-base lg:text-xl text-black openSans-Reg">
                            I agree to all fixed &nbsp;
                            <a
                                href="javascript:;"
                                title="Bank Charges"
                                className="blue-link-color no-underline hover:underline hover:text-black transition-all openSans-SemiBold modal-open"
                                onClick={() => setBankChargePopupSwitch(true)}
                            >
                                Bank Charges
                            </a>
                        </span>
                    </label>
                </div>
                <span
                    className={
                        (!leadError["LDIAgree"] ? "hidden" : "") +
                        " error-msg-relative text-red-600 openSans-Reg text-xs md:text-sm lg:text-sm xl:text-sm"
                    }
                >
                    {leadError["LDIAgree"]}
                </span>
                {/* <!-- Bank Charges Popup Start --> */}
                {bankChargePopupSwitch ? (
                    <ModalPopUp
                        onclickhandler={() => setBankChargePopupSwitch(false)}
                    >
                        <LoanBankCharge />
                    </ModalPopUp>
                ) : (
                    ""
                )}

                {/* <!-- Bank Charges Popup End --> */}
            </div>
        </>
    );
}

export default BankChargeAgree;
